import { useEffect } from 'react';
import Api from 'entities/helpers/api';
import EverTrue from 'app';
import { Loading } from '@evertrue/et-components';
import { useGlobalDrawerProvider } from 'components/drawer/context/global-drawer-context';
import ErrorLogger from 'entities/helpers/error-log-helper';

const OauthRedirectController = () => {
  const { addDrawer } = useGlobalDrawerProvider();
  useEffect(() => {
    const url = new URL(window.location.href);
    const code = url.searchParams.get('code');
    let oauthData = {};
    try {
      oauthData = JSON.parse(localStorage.getItem('oauthData')) || {};
    } catch (e) {
      oauthData = {};
    }
    const { prevLocation } = oauthData;
    localStorage.removeItem('oauthData');

    const redirectBack = () => {
      if (prevLocation && prevLocation.includes('/contact')) {
        addDrawer('emailer');
      }
      const navigateTo = typeof prevLocation === 'string' ? prevLocation.slice(1) || '/contact' : '/contact';
      EverTrue.Navigator(navigateTo, { trigger: true, replace: true });
    };

    if (code) {
      Api.OUTREACH.LINK.post({
        data: JSON.stringify({
          auth: { code },
        }),
        disableAlerts: true,
      })
        .then(() => {
          EverTrue.Alert.success(`Your account has been connected successfully!`);
          redirectBack();
        })

        .catch((xhr) => {
          if (xhr?.status !== 0) {
            ErrorLogger.captureRequest('Error linking email account', xhr);
          }
          EverTrue.Alert.error(`There was a problem linking your account. Please try again.`);
          redirectBack();
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loading />;
};

export default OauthRedirectController;
